import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { baseUniDriverFactory } from '../../testkitUtils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { modalDriverFactory } from '../internal/Modal/Modal.driver';

export interface MobileDrawerDriver extends BaseUniDriver {
  childExists(predicate: string): Promise<boolean>;
  isOpen(): Promise<boolean>;
}

export const mobileDrawerDriverFactory = (
  base: UniDriver,
  body: UniDriver,
): MobileDrawerDriver => {
  return {
    ...baseUniDriverFactory(base),

    /**
     * Checks whether a node with the provided predicate exists.
     * @param {string} predicate - a predicate for the child node
     * @returns {Promise<boolean>}
     */
    childExists: async (predicate: string) => {
      const modalDriver = modalDriverFactory(base, body);
      return modalDriver.childExists(predicate);
    },

    /**
     *  Checks whether the Drawer is open.
     *  @returns {Promise<boolean>}
     */
    isOpen: async () => {
      const modalDriver = modalDriverFactory(base, body);
      return modalDriver.isOpen();
    },
  };
};
